import React from "react"
import { css, type Theme } from "@emotion/react"
import LogoV from "@myvp/shared/src/logos/logo-v"
import { DO_NOT_TRANSLATE_CONSTANTS } from "@myvp/shared/src/constants"
import breakpoints from "@myvp/shared/src/styles/breakpoints"

const headerCss = (theme: Theme) => css`
  font-family: var(--logo-fontFamily);
  font-size: 1.25rem;
  font-weight: normal;
  line-height: 1.25rem;
  color: ${theme.palette.content.neutral.inverse};
  letter-spacing: -0.015em;
  padding-bottom: 1px;
  margin: 0;

  ${breakpoints("md")} {
    display: none;
  }
`

const EcoaLogo = (props: {
  className?: string
  boldText?: string
  productName?: string
}) => (
  <div
    className={props.className}
    css={css`
      display: flex;
      height: 25px;
      align-items: center;
    `}
  >
    <LogoV />
    <h1 css={headerCss}>
      <span
        css={css`
          font-weight: 700;
          letter-spacing: -0.015em;
          font-size: 1.25rem;
          margin: 0;
        `}
      >
        {props.boldText ?? DO_NOT_TRANSLATE_CONSTANTS.ecoa}{" "}
      </span>
      {props.productName}
    </h1>
  </div>
)

export default EcoaLogo
